var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hiq-header-lgw__origin"},[(_vm.originLink.originUri)?_c('a',{attrs:{"href":_vm.originLink.originUri,"target":"_blank"}},[_c('img',{staticClass:"hiq-header-lgw__origin-image",attrs:{"src":_vm.originLink.imageUri,"alt":"Till Luleå kommun (Öppnas i nytt fönster)"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }